var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-error-box"},[_c('el-image',{attrs:{"src":"https://img01.ssrelease.com/0513/M00/CC/B1/ChAKCGVUjWOADLKmAAOA_SdWgwQ834.png"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }